import { render, staticRenderFns } from "./KnowledgeSearchExpand.vue?vue&type=template&id=4c6b6aca&scoped=true&"
import script from "./KnowledgeSearchExpand.vue?vue&type=script&lang=js&"
export * from "./KnowledgeSearchExpand.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeSearchExpand.vue?vue&type=style&index=0&id=4c6b6aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6b6aca",
  null
  
)

export default component.exports